import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'fr', 'it'];

export const LanguageRouter = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];

    // If URL starts with a language code, change i18n language
    if (SUPPORTED_LANGUAGES.includes(firstSegment)) {
      if (i18n.language !== firstSegment) {
        i18n.changeLanguage(firstSegment);
      }
    }
    // Redirects for landing pages are handled by App.tsx routes
  }, [location.pathname, i18n]);

  return <>{children}</>;
};
